var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sports-entertainment"},[_c('div',{staticClass:"sports-entertainment__label"},[_vm._v("Sport i relaks")]),_vm._v(" "),_c('CheckList',{staticClass:"sports-entertainment__body",attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee0a6d80","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/fields/SportsEntertainmentDropdown.vue
// module id = 846
// module chunks = 1